<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>
                    {{ $store.state.analytics.title }} <v-spacer></v-spacer>
                </h3>
                <v-spacer></v-spacer>
                <v-btn v-if="dashboard" dark icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                <v-btn v-else dark icon to="/shift-analytics"><v-icon>mdi-arrow-left</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table dense :headers="headers" :items="items" :search="search" height="600px"
                    disable-items-per-page disable-pagination class="custom-table" hide-default-footer
                    :fixed-header="true" v-if="show == 1">
                    <!------------------------------------- Bar Search ------------------------------------------->
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model="search" label="Search" class="mb-1" dense
                                    style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-btn color="success" class="float-left" @click="exportExcel"
                                    icon><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                            </v-col>

                            <v-col cols="1" v-if="$store.state.analytics.title == 'View By Company Truck' || $store.state.analytics.title == 'View By Company Truck Actual Profit'">
                                <v-switch v-model="RatePaid" label="Rate Paid" dense class="my-auto" hide-details @change="getItems">
                                </v-switch>
                            </v-col>
                        </v-row>

                        <!-------------------------------------TB Totals Header ------------------------------------------->
                        <table style="width: 100%;" class="tbla" dense v-if="view">
                            <thead>
                                <tr class="text-center">
                                    <td :width="ttWidth" class="text-right">Totals</td>
                                    <th :width="ttResult" scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        $
                                        {{
                        new Intl.NumberFormat().format(
                            Number(Revenue).toFixed(2)
                        )
                    }}
                                    </th>
                                    <th :width="ttResult" scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        $
                                        {{
                        new Intl.NumberFormat().format(
                            Number(OtherRev).toFixed(2)
                        )
                    }}
                                    </th>
                                    <th :width="ttResult" scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        $
                                        {{
                        new Intl.NumberFormat().format(
                            Number(Expenses).toFixed(2)
                        )
                    }}
                                    </th>
                                    <th :width="ttResult" scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        $
                                        {{
                        new Intl.NumberFormat().format(
                            Number(OtherExp).toFixed(2)
                        )
                    }}
                                    </th>
                                    <th :width="ttResult" scope="col" colspan="1"
                                        style="background-color: #336ca5; color: aliceblue;"></th>
                                    <th style="background-color: #336ca5; color: aliceblue;"></th>
                                </tr>
                                <tr>
                                    <td width="9%" class="text-right">Grand Totals</td>

                                    <th scope="col" style="background-color: #336ca5; color: aliceblue;"></th>
                                    <th scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        ${{
                        new Intl.NumberFormat().format(
                            Number(
                                OtherRev + Revenue
                            ).toFixed(2)
                        )
                    }}
                                    </th>
                                    <th style="background-color: #336ca5; color: aliceblue;"></th>
                                    <th scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        ${{
                            new Intl.NumberFormat().format(
                                Number(
                                    Expenses + OtherExp
                                ).toFixed(2)
                            )
                        }}
                                    </th>
                                    <th scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        ${{
                            new Intl.NumberFormat().format(
                                Number(Net).toFixed(2)
                            )
                        }}
                                    </th>
                                    <th scope="col" class="text-center"
                                        style="background-color: #336ca5; color: aliceblue;">
                                        {{
                            Number(
                                (Net / (OtherRev + Revenue)) *
                                100
                            ).toFixed(2)
                        }}
                                        %
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </template>
                    <!------------------------------------- Templates ------------------------------------------->
                    <template v-slot:item.Revenue="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.Revenue).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.OtherRev="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.OtherRev).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.Expenses="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.Expenses).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.OtherExp="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.OtherExp).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.net="{ item }">
                        <td style="text-align: right;">
                            $
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.net).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.Margin="{ item }">
                        <td style="border:1px #4f83cc solid;text-align: right;" class="hover" @click="open(item,dashboard)">
                            {{ item.Margin }}
                        </td>
                    </template>
                    <template v-slot:item.CountRplcUnt="{ item }">
                        <td style="border:1px #4f83cc solid;text-align: right;" class="hover"
                            @click="openDrDown(item, 0)">
                            {{ item.CountRplcUnt }}
                        </td>
                    </template>
                    <template v-slot:item.TruckNameProf="{ item }">
                        <td style="border:1px #4f83cc solid;text-align: right;" class="hover"
                            @click="openDrDown(item, 1)">
                            {{ item.TruckNameProf }}
                        </td>
                    </template>
                    <template v-slot:item.TruckCost="{ item }">
                        <td style="border:1px #4f83cc solid;text-align: right;" class="hover"
                            @click="openModal(item, 1)">$
                            {{
                        new Intl.NumberFormat().format(
                            Number(item.TruckCost).toFixed(2)
                        )
                    }}
                        </td>
                    </template>
                    <template v-slot:item.TotalRevenue="{ item }">
                        ${{
                        new Intl.NumberFormat().format(
                            Number(item.TotalRevenue).toFixed(2)
                        )
                    }}
                    </template>
                    <template v-slot:item.DriverPay="{ item }">
                        ${{
                        new Intl.NumberFormat().format(
                            Number(item.DriverPay).toFixed(2)
                        )
                    }}
                    </template>
                    <template v-slot:item.Net="{ item }">
                        $
                        {{
                        new Intl.NumberFormat().format(
                            Number(item.Net).toFixed(2)
                        )
                    }}
                    </template>
                    <template v-slot:item.PayRollMargin="{ item }">
                        {{ item.PayRollMargin }}
                    </template>
                    <template v-slot:item.NetMargin="{ item }">
                        {{ item.NetMargin }}
                    </template>
                    <template v-slot:item.TruckPercent="{ item }">
                        {{ item.TruckPercent }}
                    </template>
                    <template v-slot:item.GPSOdoDiff="{ item }">

                        {{ new Intl.NumberFormat().format(
                        Number(item.GPSOdoDiff).toFixed(2)
                    ) }}
                    </template>
                    <template v-slot:item.SumOfStdKm="{ item }">
                        {{ new Intl.NumberFormat().format(
                        Number(item.SumOfStdKm).toFixed(2)
                    ) }}
                    </template>
                    <!-- <template v-slot:item.GPSOdoDiff="{ item }">
                        {{ Number(item.GPSOdoDiff).toFixed(2).toLocaleString() }}
                    </template> -->
                    <template v-slot:item.FuelLiters="{ item }">
                        {{ new Intl.NumberFormat().format(
                        Number(item.FuelLiters).toFixed(2)
                    ) }}
                    </template>
                    <template v-slot:item.KmsTotal="{ item }">
                        {{ new Intl.NumberFormat().format(
                        Number(item.KmsTotal).toFixed(2)
                    ) }}
                    </template>
                    <template v-slot:item.FuelEfficiency="{ item }">
                        {{ item.FuelEfficiency }}
                    </template>
                </v-data-table>
                <!------------------------------------- Spinner ------------------------------------------->
                <v-container style="height: 400px;" v-else>
                    <v-row class="fill-height" align-content="center" justify="center">
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Getting your files
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear color="primary accent-4" indeterminate rounded
                                height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                <!-------------------------------------TB Totals Fuel Efficiency------------------------------------------->
                <table style="width: 100%;" class="tbla" dense v-if="$store.state.analytics.title == 'Fuel Efficiency'">
                    <thead>
                        <tr class="text-center">
                            <td :width="ttWidth" class="text-right">Totals</td>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['FuelLiters']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['KmsTotal']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ Number((totals['FuelLiters'] / totals['KmsTotal']) * 100).toFixed(2) }}%7
                            </th>
                        </tr>
                    </thead>
                </table>
                <!-------------------------------------TB Totals Fuel Efficiency------------------------------------------->
                <table style="width: 100%;" class="tbla" dense
                    v-if="$store.state.analytics.title == 'Hours & Kms Standar vs Actual'">
                    <thead>
                        <tr class="text-center">
                            <td :width="ttWidth" class="text-right">Totals</td>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['GPSOdoDiff']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['SumOfStdKm']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['GPSOdoDiff']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['KmVariance']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['SumOfStdHrs']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['SumOfGPSHrs']).toFixed(2)
                    ) }}
                            </th>
                            <th :width="ttResult" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(
                        Number(totals['HrsVariance']).toFixed(2)
                    ) }}
                            </th>
                        </tr>
                    </thead>
                </table>
                <!-------------------------------------TB Totals Actul Cost Profit----------------------------------------->
                <table style="width: 100%;" class="tbla" dense
                    v-if="$store.state.analytics.title == 'View By Company Truck Actual Profit'">
                    <thead>
                        <tr class="text-center">
                            <td width="10%" class="text-right">Totals</td>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                        Number(MainUnite).toFixed(2).toLocaleString()
                    }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">

                                {{
                            Number(MainReplace).toFixed(2).toLocaleString()
                        }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new
                                Intl.NumberFormat().format(Number(totals['TTTotalRevenue']).toFixed(2).toLocaleString())
                        }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new
                                Intl.NumberFormat().format(Number(totals['TotalDriverPay']).toFixed(2).toLocaleString())
                        }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new
                                Intl.NumberFormat().format(Number(totals['TotalTruckCost']).toFixed(2).toLocaleString())
                        }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new Intl.NumberFormat().format(Number(totals['TotalNet']).toFixed(2).toLocaleString())
                        }}
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ Number(((totals['TTTotalRevenue'] - parseInt(totals['TotalDriverPay']) -
                        totals['TotalTruckCost']) /
                        totals['TTTotalRevenue']) * 100).toFixed(2) }} %
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ Number((parseInt(totals['TotalDriverPay']) / totals['TTTotalRevenue']) *
                        100).toFixed(2) }} %
                            </th>
                            <th width="10%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ Number(((totals['TotalTruckCost']) / totals['TTTotalRevenue']) * 100).toFixed(2) }} %
                            </th>
                        </tr>
                    </thead>
                </table>
                <v-simple-table style="width: 100%;" class="tbla" dense
                    v-if="$store.state.analytics.title == 'View By Company Truck'">
                    <thead>
                        <tr class="text-center">
                            <td width="6.25%" class="text-right">Totals</td>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                        new Intl.NumberFormat().format(Number(totals['Revenue']).toFixed(2).toLocaleString())
                    }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            Number(totals['OtherRev']).toFixed(2).toLocaleString()
                        }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new
                                Intl.NumberFormat().format(Number(totals['TotRevenueL']).toFixed(2).toLocaleString())
                        }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                            new
                                Intl.NumberFormat().format(Number(totals['CompRevenue']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{
                        new
                            Intl.NumberFormat().format(Number(totals['OtherCompRevenue']).toFixed(2).toLocaleString())
                    }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['TotRevenueT']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(Number(totals['Payroll']).toFixed(2).toLocaleString())
                                }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['Maintenance']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['FuelConsumption']).toFixed(2).toLocaleString())
                                }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['TotalExpenses']).toFixed(2).toLocaleString())
                                }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['GainOrLossL']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['GainOrLossT']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-right"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                        Intl.NumberFormat().format(Number(totals['DriverMargin']).toFixed(2).toLocaleString())
                                }}
                            </th>

                            <th width="6.25%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new Intl.NumberFormat().format(Number(totals['KM']).toFixed(2).toLocaleString()) }}
                            </th>
                            <th width="6.25%" scope="col" class="text-center"
                                style="background-color: #336ca5; color: aliceblue;">
                                {{ new
                                Intl.NumberFormat().format(Number(totals['FuelEfficiiency']).toFixed(2).toLocaleString())
                                }}
                            </th>
                        </tr>
                    </thead>
                </v-simple-table>

            </v-container>
        </v-card>
        <TruckCost v-if="$store.state.analytics.truckCost"></TruckCost>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import TruckCost from './../Modals/ShiftAnalysis/TruckCost.vue';
import axios from 'axios';
export default {
    directives: { mask },
    props:['dashboard'],
    components: {
        TruckCost
    },
    data: function () {
        return {
            items: [],
            headers: [],
            search: '',
            colspan: 0,
            show: 0,
            drillDown: '',
            Revenue: 0,
            OtherRev: 0,
            Expenses: 0,
            OtherExp: 0,
            ttWidth: '40%',
            ttResult: '10%',
            liters: 0,
            Kms: 0,
            fuelEf: 0,
            Net: 0,
            view: true,
            TotalTCost: 0,
            TotalDCost: 0,
            TotalProfit: 0,
            MainUnite: 0,
            TotalRev: 0,
            MainReplace: 0,
            totals: [],
            RatePaid: false,
        };
    },
    mounted() {
        switch (this.$store.state.analytics.title) {
            case 'View By Shift':
                this.ttWidth = '50.2%';
                this.ttResult = '8.3%';
                this.headers = [
                    { align: 'right', text: 'Date', value: 'Date', width: '8%' },
                    { align: 'right', text: 'Shift', value: 'Shift', width: '4%' },
                    { align: 'right', text: 'ShiftDetail', value: 'ShiftDetail', width: '7%' },
                    { align: 'right', text: 'Driver', value: 'DriverName', width: '15%' },
                    { align: 'right', text: 'Truck', value: 'TruckName', width: '5%' },
                    { align: 'right', text: 'Trailer', value: 'TrailerName', width: '5%' },
                    { align: 'right', text: 'Yard', value: 'Yard', width: '5%' },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/transacting';
                this.colspan = 7;
                break;
            case 'View By Truck':
                this.headers = [
                    // {align: 'right', text: 'TruckID', value: 'TruckID', width: '8%' },
                    { align: 'left', text: 'Truck', value: 'Name', width: this.ttWidth },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/truck';
                break;
            case 'View By Trailer':
                this.headers = [
                    // {align: 'right', text: 'TruckID', value: 'TruckID', width: '8%' },
                    { align: 'left', text: 'Trailer', value: 'Name', width: this.ttWidth },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/trailer';
                break;
            case 'View By Driver':
                this.headers = [
                    // {align: 'right', text: 'ID', value: 'DriverID', width: '8%' },
                    { align: 'left', text: 'Driver', value: 'DriverName',width: '20%' },
                    { align: 'left', text: 'Driver Type', value: 'DriverType', width: '20%' },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/driver';
                break;
            case 'View By Customer':
                this.headers = [
                    { align: 'left', text: 'Customer', value: 'Name', width: this.ttWidth },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/customer';
                break;
            case 'View By Truck-Yard':
                this.headers = [
                    // {align: 'right', text: 'YardId', value: 'YardId', width: '8%' },
                    { align: 'left', text: 'Yard', value: 'Yard', width: '40%' },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/truck-yard';
                break;
            case 'View By Station':
                this.headers = [
                    // {align: 'right', text: 'StationID', value: 'Station', width: '8%' },
                    { align: 'left', text: 'Station', value: 'StationName', width: '20%' },
                    { align: 'right', text: 'City', value: 'City', width: '10%' },
                    { align: 'right', text: 'PRegion', value: 'PRegion', width: '10%' },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/station';
                break;
            case 'View By Terminal':
                this.headers = [
                    // {align: 'right', text: 'TerminalID', value: 'TerminalID', width: '8%' },
                    { align: 'left', text: 'Terminal', value: 'TerminalName', width: this.ttWidth },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: this.ttResult },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: this.ttResult },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: this.ttResult },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: this.ttResult },
                    { align: 'right', text: 'Net', value: 'net', width: this.ttResult },
                    { align: 'right', text: 'Margin', value: 'Margin', width: this.ttResult }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/terminal';
                break;
            case 'View Regions Totals':
                this.headers = [
                    // {align: 'right', text: 'ID', value: 'PrincipalRegionID', width: '8%' },
                    { align: 'left', text: 'Region', value: 'PrincipalRegion', width: this.ttWidth },
                    { align: 'right', text: 'Revenue', value: 'Revenue', width: '10%' },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev', width: '10%' },
                    { align: 'right', text: 'Expenses', value: 'Expenses', width: '10%' },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp', width: '10%' },
                    { align: 'right', text: 'Net', value: 'net', width: '10%' },
                    { align: 'right', text: 'Margin', value: 'Margin', width: '10%' }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/region-totals';
                break;
            case 'Revenues by Invoice':
                this.headers = [
                    { align: 'right', text: 'Invoice Id', value: 'InvId', width: '8%' },
                    { align: 'right', text: 'Invoice Date', value: 'InvDate', width: '20%' },
                    { align: 'right', text: 'Revenue', value: 'Revenue' },
                    { align: 'right', text: 'OtherRev', value: 'OtherRev' },
                    { align: 'right', text: 'MaxOfOrderTotal', value: 'MaxOfOrderTotal' }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/region-totals';
                this.view = false;
                break;
            case 'Expenses by Statements':
                this.headers = [
                    { align: 'right', text: 'Payroll Id', value: 'PayId', width: '8%' },
                    { align: 'right', text: 'Payroll Date', value: 'DatePayId', width: '20%' },
                    { align: 'right', text: 'Expenses', value: 'Expenses' },
                    { align: 'right', text: 'OrderTotal', value: 'OrderTotal' },
                    { align: 'right', text: 'OtherExp', value: 'OtherExp' }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/region-totals';

                this.view = false;
                break;
            case 'View By Company Truck':
                this.headers = [
                    { align: 'right', text: 'Truck', value: 'Truck', width: '6.25%' },
                    { align: 'right', text: 'Revenue L', value: 'Revenue', width: '6.25%' },
                    { align: 'right', text: 'OtherRev L', value: 'OtherRev', width: '6.25%' },
                    { align: 'right', text: 'Tot Rev. L', value: 'TotRevenueL', width: '6.25%' },
                    { align: 'right', text: 'Revenue T', value: 'CompRevenue', width: '6.25%' },
                    { align: 'right', text: 'OtherRev T', value: 'OtherCompRevenue', width: '6.25%' },
                    { align: 'right', text: 'Tot Rev. T', value: 'TotRevenueT', width: '6.25%' },
                    { align: 'right', text: 'Payroll', value: 'Payroll', width: '6.25%' },
                    { align: 'right', text: 'Maintenance', value: 'Maintenance', width: '6.25%' },
                    { align: 'right', text: 'Fuel Consup', value: 'FuelConsumption', width: '6.25%' },
                    { align: 'right', text: 'Tot Expenses', value: 'TotalExpenses', width: '6.25%' },
                    { align: 'right', text: 'Gain or Loss L', value: 'GainOrLossL', width: '6.25%' },
                    { align: 'right', text: 'Gain or Loss T', value: 'GainOrLossT', width: '6.25%' },
                    { align: 'right', text: 'Margin', value: 'DriverMargin', width: '6.25%' },
                    { align: 'right', text: 'Kms', value: 'KM', width: '6.25%' },
                    { align: 'right', text: 'FuelEff', value: 'FuelEfficiiency', width: '6.25%' }
                ];

                this.view = false;
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/company-truck';
                break;
            case 'View By Company Truck Actual Profit':
                this.headers = [
                    { align: 'right', text: 'Truck', value: 'TruckNameProf', width: '10%' },
                    { align: 'right', text: 'Main Unit', value: 'CountShift', width: '10%' },
                    {
                        text: 'Replace Unit',
                        value: 'CountRplcUnt',
                        width: '10%'
                    },
                    { align: 'right', text: 'Total Revenue', value: 'TotalRevenue', width: '10%' },
                    { align: 'right', text: 'Driver Cost', value: 'DriverPay', width: '10%' },
                    { align: 'right', text: 'Truck Cost', value: 'TruckCost', width: '10%' },
                    { align: 'right', text: 'Profit', value: 'Net', width: '10%' },
                    { align: 'right', text: 'ProfitMargin', value: 'NetMargin', width: '10%' },
                    { align: 'right', text: 'Driver Percent', value: 'PayRollMargin', width: '10%' },
                    { align: 'right', text: 'Truck Percent', value: 'TruckPercent', width: '10%' }
                ];
                this.view = false;
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis By Company Costs';
                break;
            case 'Fuel Efficiency':
                this.headers = [
                    // {align: 'right', text: 'TruckID', value: 'TruckID', width: '8%' },
                    { align: 'left', text: 'Truck', value: 'Truck', width: this.ttWidth },
                    { align: 'right', text: 'FuelLiters', value: 'FuelLiters', width: this.ttResult },
                    { align: 'right', text: 'KmsTotal', value: 'KmsTotal', width: this.ttResult },
                    { align: 'right', text: 'FuelEfficiency', value: 'FuelEfficiency', width: this.ttResult },
                ];
                this.view = false;
                break;
            case 'Hours & Kms Standar vs Actual':

                this.ttWidth = "30%"
                this.headers = [
                    // {align: 'right', text: 'TruckID', value: 'TruckID', width: '8%' },
                    { align: 'left', text: 'Truck', value: 'Truck', width: this.ttWidth },
                    { align: 'left', text: 'Driver', value: 'GPSOdoDiff', width: this.ttResult },
                    { align: 'right', text: 'Standar', value: 'SumOfStdKm', width: this.ttResult },
                    { align: 'right', text: 'GPS', value: 'GPSOdoDiff', width: this.ttResult },
                    { align: 'right', text: 'Variance', value: 'KmVariance', width: this.ttResult },

                    { align: 'right', text: 'Standar', value: 'SumOfStdHrs', width: this.ttResult },
                    { align: 'right', text: 'Actual', value: 'SumOfGPSHrs', width: this.ttResult },
                    { align: 'right', text: 'Variance', value: 'HrsVariance', width: this.ttResult },
                ];
                this.view = false;
                break;
        }
        this.getItems();
    },
    methods: {
        getItems: function () {
            this.Revenue = 0;
            this.OtherRev = 0;
            this.Expenses = 0;
            this.liters = 0;
            this.Kms = 0;
            this.OtherExp = 0;
            this.fuelEf = 0;
            this.TotalRev = 0;
            this.TotalTCost = 0;
            this.TotalDCost = 0;
            this.TotalProfit = 0;
            this.MainUnite = 0;
            this.MainReplace = 0;
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                RatePaid: this.RatePaid
            };
            console.log(parms);
            axios
                .post(this.$store.state.analytics.url, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.show = 1;
                    if (!this.view) {
                        this.items = response.data['data'];
                        this.totals = response.data['totals'][0];
                        console.log(this.totals)
                    } else {
                        this.items = response.data;
                    }
                    console.log(this.items, this.headers );
                    this.items.forEach(element => {
                        this.Revenue = element.Revenue + this.Revenue;
                        this.OtherRev = element.OtherRev + this.OtherRev;
                        this.Expenses = element.Expenses + this.Expenses;
                        this.OtherExp = element.OtherExp + this.OtherExp;
                        this.Net = element.net + this.Net;
                        this.liters = parseInt(element.FuelLiters) + this.liters;
                        this.Kms = parseInt(element.KmsTotal) + this.Kms;
                        this.fuelEf = parseInt(element.FuelEfficiency) + this.fuelEf;
                        this.TotalRev = parseInt(element.TotalRevenue) + this.TotalRev;
                        this.TotalTCost = parseInt(element.TruckCost) + this.TotalTCost;
                        this.TotalDCost = parseInt(element.DriverPay) + this.TotalDCost;
                        this.TotalProfit = parseInt(element.Net) + this.TotalProfit;
                        this.MainUnite = parseInt(element.CountShift) + this.MainUnite;
                        this.MainReplace = parseInt(element.CountRplcUnt) + this.MainReplace;
                    });

                    
                })
                .catch(function (error) {
                    console.log(error);
                    this.show = 1;
                });
        },
        exportExcel: function () {
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                Export: 1
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post(this.$store.state.analytics.url, parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.$store.state.analytics.title + '.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        openDrDown: function (itm, elm) {
            if (elm == 1) {
                this.$store.state.analytics.specific =
                    'shift-analytics/actual-cost/truck';
            } else {
                this.$store.state.analytics.specific =
                    'shift-analytics/actual-cost/rplunite';
            }
            this.$store.state.analytics.itm = itm;
            this.$store.state.analytics.return = '/shift-analytics-detail';
            this.$router.push(this.drillDown);
        },
        openModal: function (itm) {
            this.$store.state.analytics.itm = itm;
            this.$store.state.analytics.truckCost = true;
        },
        open: function (itm, dashboard) {
            if(dashboard){
                console.log(dashboard);
                this.$store.state.analytics.itm = itm;
                this.$store.state.analytics.return = '/shift-analytics-detail';
                this.$emit('drilldown');
            }else{
                this.$store.state.analytics.itm = itm;
                this.$store.state.analytics.return = '/shift-analytics-detail';
                this.$router.push(this.drillDown);
            }
        }
    }
};
</script>
<style>
.hover:hover {
    background: #a4a9de;
}

.v-data-table-header th {
    background: #336ca5;
}

.custom-table .v-data-table-header>th {
    background-color: #336ca5;
    /* Cambia este color al que desees */
    color: white;
    /* Cambia este color al que desees */
}
</style>
